import React, { useEffect } from "react";
import "./IndexMeNow.css";
// import POST from "../../../Apis/backlink/Post";
import { getAPIUrlBM } from "../../../utils/config";
import GET from "../../../Apis/backlink/Get";
import AccountTile from "./AccountTile/AccountTile";
import { useNavigate } from "react-router-dom";
import { auth2 } from "../../../firebase";
import { createCheckoutSession } from "../Pricing/stripeFunctions";
import TipLoader from "../../utils/TipLoader/TipLoader";
import { PlanInfo } from "../../utils/backLinkPlanInfo";

const IndexMeNow = ({ product }) => {
  const callingFrom = product === "indexme" ? "indexme" : "backlink";
  const navigate = useNavigate();
  const [userConsoleData, setUserConsoleData] = React.useState([]);
  const [totalDomains, setTotalDomains] = React.useState(0);
  const [usedDomains, setUsedDomains] = React.useState(0);
  const [qty, setQty] = React.useState(3);
  const [loading, setLoading] = React.useState(false);
  const [plan, setPlan] = React.useState("plan1");
  // useEffect(() => {
  //   auth2.currentUser.getIdTokenResult().then((idTokenResult) => {
  //     console.log(idTokenResult.claims, "CUSTOM_CLAIMS");
  //     const { addOns, plan: myplan } = idTokenResult.claims;

  //     if (myplan) setPlan(myplan);
  //     if (Array.isArray(addOns)) {
  //       const indexmenow = addOns.find((item) => item.name === "indexmenow");

  //       if (indexmenow) {
  //         setTotalDomains(indexmenow.limit);
  //         // setUsedDomains(indexmenow.usedDomains);
  //       }
  //     }
  //   });
  // }, []);
  const getAuthenticationUrlForIndexMeNow = async () => {
    try {
      const response = await GET(
        getAPIUrlBM() +
          (product === "indexme"
            ? "/get-indexme-authentication-url/?authorId="
            : "/get-authentication-url/?authorId=") +
          localStorage.getItem("userid"),
      );
      const { data } = response;
      if (data?.length > 0) {
        const popup = window.open(
          data,
          "GoogleAuthPopup",
          "width=600,height=600",
        );
        const interval = setInterval(() => {
          if (popup?.closed) {
            clearInterval(interval);
            getUserConsoleData();
          }
        }, 1500);
      }
      console.log(data);
    } catch (error) {
      console.log(error);
    }
  };
  const getUserConsoleData = async () => {
    try {
      const response = await GET(getAPIUrlBM() + "/get-user-console-data/");
      const { data, backLinkLimits } = response;
      console.log(backLinkLimits);
      if (backLinkLimits) {
        setUsedDomains(backLinkLimits["POST/active-domain"] || 0);
      }
      setUserConsoleData(data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getUserConsoleData();
  }, []);
  return (
    <div className="invite">
      {loading && <TipLoader product={product} />}
      <h1 className="header_component_indexmenow">Index My Site</h1>
      <span
        className="how_it_works_for_indexmenow"
        onClick={() => {
          window.open(
            product === "indexme"
              ? "https://app.supademo.com/demo/cls85uu3d0taepenadrxtwact"
              : "https://app.supademo.com/demo/clqfbxauw3pngpetz01uhg8nq",
            "_blank",
          );
        }}
      >
        How it Works?{" "}
        <svg
          width="12"
          height="12"
          viewBox="0 0 12 12"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.55 0.858814H8.21636L8.19298 0.858317C8.16961 0.856327 8.14648 0.853592 8.12335 0.848245C8.07014 0.836309 8.01916 0.813429 7.97464 0.781726C7.85852 0.69954 7.79137 0.559783 7.79921 0.417651C7.80144 0.378608 7.80928 0.33994 7.82208 0.303135C7.83763 0.258872 7.8605 0.217094 7.88972 0.180537C7.92404 0.13764 7.96631 0.101706 8.01419 0.0752234C8.05547 0.0527184 8.10023 0.0368041 8.14648 0.0289706C8.16712 0.0256135 8.17209 0.0256135 8.19298 0.0236241C9.31786 -0.00783315 10.4445 -0.00783314 11.5695 0.0233755H11.5743L11.5776 0.0236241H11.5821C11.5859 0.0241215 11.5899 0.0244945 11.5938 0.0247432L11.6055 0.0256135C11.6328 0.0298409 11.64 0.0300894 11.6668 0.0373012C11.6757 0.039788 11.6843 0.0422748 11.693 0.0451345L11.6966 0.0465022L11.7047 0.0496106L11.7119 0.0520974L11.7186 0.0548328L11.7228 0.0568222C11.7432 0.0654014 11.7624 0.0754728 11.781 0.0871602C11.8163 0.109417 11.8482 0.136771 11.8754 0.168477C11.8885 0.183771 11.9005 0.199935 11.9113 0.216968L11.9122 0.218335C11.9248 0.238105 11.9356 0.258992 11.9448 0.281003C11.9556 0.307487 11.9632 0.33422 11.9684 0.361823L11.9693 0.366051C11.9704 0.372765 11.9715 0.379106 11.9724 0.385572C11.9738 0.39614 11.9749 0.406709 11.976 0.41765C12.0075 1.53894 11.9765 2.66131 11.9765 3.78307C11.976 3.80396 11.9762 3.80931 11.974 3.82982C11.9687 3.87632 11.9554 3.92196 11.935 3.96436C11.9113 4.0136 11.8779 4.05823 11.8372 4.09441C11.808 4.12065 11.7751 4.14266 11.74 4.15932C11.6043 4.22472 11.4397 4.21079 11.3169 4.12363C11.2787 4.09665 11.245 4.06296 11.218 4.02478C11.1818 3.97381 11.1574 3.91475 11.1468 3.85295C11.1429 3.82983 11.1414 3.8067 11.1409 3.78307V1.4494L5.72693 6.86374C5.70654 6.88239 5.70181 6.88799 5.67955 6.9044C5.64586 6.92914 5.6088 6.94866 5.56927 6.96259C5.52028 6.97987 5.46793 6.9877 5.41584 6.98571C5.27906 6.98074 5.15038 6.90639 5.07777 6.79051C5.05551 6.75519 5.03872 6.71665 5.02791 6.67637C5.01709 6.63621 5.01237 6.59418 5.01398 6.55265C5.01672 6.47966 5.03872 6.4078 5.07777 6.346C5.09443 6.31927 5.11457 6.29589 5.13596 6.27277L10.5503 0.858744L10.55 0.858814Z"
            fill="#0048A1"
          />
          <path
            d="M5.47049 1.1387C5.50531 1.14367 5.51451 1.14367 5.54845 1.15375C5.62504 1.176 5.69442 1.22064 5.74652 1.2807C5.77276 1.31078 5.79439 1.34448 5.8108 1.38066C5.82746 1.41684 5.83865 1.45564 5.8445 1.4948C5.86153 1.61367 5.8256 1.73689 5.74677 1.82791C5.71195 1.86807 5.66968 1.90139 5.62256 1.92564C5.57543 1.94988 5.52371 1.96518 5.47074 1.97015C5.45769 1.97152 5.44426 1.97152 5.4312 1.97214C5.13827 1.97214 4.84521 1.97239 4.55227 1.9735C4.07905 1.97624 3.60557 1.97997 3.13296 2.00583C2.87036 2.02001 2.60737 2.0409 2.34725 2.0813C2.27676 2.09212 2.20638 2.10468 2.13638 2.11923C2.08876 2.1293 2.04138 2.14012 1.99439 2.15243C1.77655 2.20863 1.55621 2.29168 1.38525 2.44263C1.35292 2.47098 1.32283 2.50194 1.29473 2.53476C1.20956 2.63423 1.14652 2.75086 1.0984 2.8721C1.04021 3.01807 1.00117 3.1715 0.971699 3.32556C0.929673 3.54302 0.90518 3.76373 0.887896 3.98394C0.858055 4.35743 0.848108 4.73208 0.842264 5.10659C0.83729 5.44218 0.836172 5.77815 0.835799 6.11396C0.83555 6.41648 0.83555 6.71887 0.835799 7.02138C0.836047 7.44638 0.837788 7.87173 0.848356 8.2967C0.857806 8.66883 0.872851 9.04198 0.915251 9.41213C0.926442 9.50961 0.939746 9.6066 0.955908 9.7032C0.985998 9.88038 1.02579 10.0574 1.08932 10.2259C1.14167 10.3649 1.21154 10.4991 1.31077 10.6109C1.50573 10.831 1.79344 10.935 2.07247 10.9999C2.13041 11.0134 2.18884 11.0253 2.24741 11.0359C2.32151 11.0493 2.39612 11.0606 2.47072 11.0704C2.85144 11.1212 3.23662 11.1378 3.62008 11.1486C4.07268 11.1612 4.52575 11.1626 4.97873 11.1628C5.28012 11.1631 5.58176 11.1631 5.88341 11.1628C6.24883 11.1626 6.61401 11.1612 6.97933 11.1542C7.34525 11.1473 7.71156 11.1358 8.07637 11.1035C8.29085 11.0846 8.50557 11.0586 8.71644 11.0144C8.89474 10.9768 9.07266 10.9266 9.23591 10.8445C9.33253 10.796 9.42341 10.7353 9.50137 10.6599C9.69547 10.4721 9.7927 10.2086 9.8551 9.95127C9.86679 9.90278 9.87736 9.85379 9.88718 9.8048C9.90136 9.73293 9.91342 9.66057 9.92399 9.58783C9.93878 9.48587 9.95047 9.38342 9.96041 9.28096C9.99212 8.95321 10.0056 8.62335 10.0139 8.29384C10.0283 7.71867 10.0264 7.14298 10.0267 6.5673L10.0287 6.52776C10.0307 6.5147 10.0318 6.50127 10.0343 6.48822C10.0443 6.43612 10.0644 6.38626 10.0933 6.3415C10.1147 6.30805 10.141 6.27771 10.171 6.25185C10.2621 6.17302 10.3853 6.13709 10.5041 6.15412C10.5437 6.15997 10.5821 6.17116 10.6183 6.18782C10.6665 6.20983 10.7104 6.24104 10.747 6.27945C10.8022 6.3374 10.8397 6.41063 10.8548 6.48884C10.8615 6.52365 10.8606 6.5326 10.8622 6.56792C10.862 6.86148 10.862 7.15503 10.8606 7.4486C10.859 7.73744 10.8564 8.02626 10.8492 8.31512C10.8442 8.51232 10.8372 8.70953 10.8261 8.90646C10.8177 9.05853 10.8068 9.21035 10.7921 9.3618C10.7832 9.45505 10.7726 9.54818 10.76 9.64118C10.7511 9.7072 10.7414 9.77323 10.7302 9.83888C10.6603 10.251 10.5413 10.667 10.2962 11.0111C10.2592 11.0635 10.2194 11.1136 10.177 11.1616C10.1107 11.2366 10.0378 11.3062 9.95979 11.3688C9.84478 11.4614 9.71858 11.5393 9.58604 11.604C9.288 11.7491 8.96099 11.8273 8.63485 11.8783C8.39948 11.9151 8.16189 11.9376 7.9244 11.9535C7.67572 11.9705 7.42619 11.9797 7.1769 11.9858C6.81842 11.995 6.45972 11.9972 6.10125 11.9984C5.72661 11.9995 5.35238 11.9992 4.97774 11.9986C4.54717 11.9984 4.11634 11.997 3.68574 11.9863C3.28936 11.9766 2.89221 11.9604 2.49818 11.9158C2.40791 11.9055 2.31764 11.8938 2.228 11.8799C1.79431 11.8125 1.35317 11.6952 0.99059 11.4381C0.938493 11.4013 0.888134 11.3615 0.84014 11.3195C0.771632 11.2591 0.708095 11.1937 0.649655 11.1234C0.608746 11.0744 0.570575 11.0228 0.53489 10.9697C0.310088 10.6344 0.199048 10.237 0.132172 9.84286C0.117376 9.75433 0.104569 9.66568 0.0935047 9.57665C0.0818169 9.48228 0.0721185 9.38729 0.0636637 9.29254C0.0497379 9.13824 0.0396664 8.98394 0.0322063 8.82938C0.0205185 8.59823 0.0138046 8.3671 0.00932825 8.13583C0.0037331 7.83692 0.00186788 7.53837 0.000997641 7.23961C-0.000370047 6.86411 -0.000121388 6.48873 0.000500291 6.11323C0.000748982 5.71162 0.00211704 5.31002 0.0105721 4.90838C0.015297 4.6811 0.0225085 4.45356 0.0348179 4.22651C0.0428999 4.07445 0.0534686 3.92263 0.068017 3.77118C0.0788342 3.6553 0.0922627 3.53979 0.108674 3.42464C0.117875 3.35949 0.128195 3.29459 0.139883 3.22968C0.210008 2.83976 0.327631 2.44786 0.559025 2.12122C0.596079 2.06912 0.635615 2.01902 0.677892 1.97115C0.744163 1.89592 0.816902 1.82654 0.895109 1.76363C1.01708 1.66528 1.15187 1.58371 1.29363 1.51682C1.56518 1.38925 1.8596 1.31539 2.15454 1.26615C2.36144 1.23159 2.57009 1.20883 2.77896 1.19205C2.99145 1.17502 3.20456 1.16445 3.41792 1.15699C3.72653 1.14617 4.03537 1.14169 4.34425 1.13945C4.70657 1.13635 5.0689 1.13697 5.43097 1.13672C5.4444 1.13722 5.45745 1.13784 5.47076 1.13871L5.47049 1.1387Z"
            fill="#0048A1"
          />
        </svg>
      </span>
      <div className="header_container_for_indexmenow">
        <div className="header_container_for_indexmenow_description">
          Check if your sitemap URLs are indexed or not. Request Google to index
          it, Automatically. <br></br> 90% + success rate in URL indexing with
          this method, if your Technical SEO is correct.
        </div>
        <div className="header_container_for_indexmenow_list">
          <span>How to use</span>
          <ul
          // add list style number
          >
            <li>Verify your Google accounts for search console access.</li>
            <li> Select the site to check for indexing. </li>
            <li>We will check all sitemap URLs and their indexing status.</li>
            <li>
              If not indexed in Google, we will automatically send Request
              Indexing call to Google.
            </li>
            <li>
              So just make sure you only add relevant pages to your sitemap.
            </li>
          </ul>
        </div>
      </div>

      <div className="limit_container_for_indexmehow">
        {/* <div>
          <span className="limit_container_for_indexmehow_header">
            As per your current plan
          </span>
          <div className="limit_container_for_indexmehow_keypair">
            <span className="limit_container_for_indexmehow_keypair_key">
              Total Domains:
            </span>
            <span className="limit_container_for_indexmehow_keypair_value">
              {+totalDomains + PlanInfo[plan].indexmenow} Domains
            </span>
          </div>
          <div className="limit_container_for_indexmehow_keypair">
            <span className="limit_container_for_indexmehow_keypair_key">
              Used Domains:
            </span>
            <span className="limit_container_for_indexmehow_keypair_value">
              {usedDomains} Domains
            </span>
          </div>
        </div> */}
        <div className="button_container_for_buydomains">
          <div className="counter mb-2">
            <button
              className="down"
              onClick={() => {
                if (qty > 1) {
                  setQty(qty - 1);
                }
              }}
            >
              -
            </button>
            <input
              type="number"
              value={qty}
              disabled
              onChange={(e) => setQty(e.target.value)}
            />
            <button className="up" onClick={() => setQty(qty + 1)}>
              +
            </button>
          </div>
          <button
            style={{
              width: "100%",
            }}
            onClick={() => {
              // navigate("/backlink/pricing");
              setLoading(true);
              createCheckoutSession(
                process.env.REACT_APP_INDEX_ME_ADDON,
                false,
                setLoading,
                qty,
                product === "indexme"
                  ? "https://www.indexmysite.co/payment-confirmation"
                  : false,
              );
            }}
          >
            BUY DOMAINS
          </button>
        </div>
      </div>

      <div
        className="create_account_button_container_for_indexmenow"
        onClick={getAuthenticationUrlForIndexMeNow}
      >
        Connect Another Account
      </div>
      {userConsoleData?.map((item) => {
        return (
          <AccountTile
            product={callingFrom}
            key={item.id + "userConsoleData"}
            // give all the props
            id={item.id}
            name={item.name}
            profile_pic={item.profile_pic}
            searchconsoleemail={item.searchconsoleemail}
            sites={item.sites}
            uuid={item.uuid}
            getAuthenticationUrlForIndexMeNow={
              getAuthenticationUrlForIndexMeNow
            }
            setUsedDomains={setUsedDomains}
          />
        );
      })}
    </div>
  );
};

export default IndexMeNow;
